module.exports = __webpack_public_path__ + "img/car-side-bolt.916033d8.svg";